import React, { useEffect, useState } from "react";
import StatsCard from "../../../components/Card/StatsCard";
import { open_api_with_cookies } from "../../../Utils/network";
import amount from "../../../assets/Icons/amount.svg";
import dollar from "../../../assets/Icons/dollar.svg";
import sales from "../../../assets/Icons/sales.svg";
import priceRise from "../../../assets/Icons/priceRise.svg";
import priceDown from "../../../assets/Icons/priceDown.svg";
import info from "../../../assets/Icons/info.svg";
import "../RevenueDashboard/RevenueDashboard.css";
import TableCard from "../../../components/Card/TableCard";
import FilterChip from "../../../components/Chip/FilterChip";
import Infocard from "../../../components/Infocard/Infocard";
import Cookies from "js-cookie";
import useAuth from "../../../Hooks/useAuth";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const years = ["2024", "2025"];
const monthsMap = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

const content = [
  "This is the revenue after commission cut by myburgo",
  "USD amt is not counted towards calculation of percentage change from the previous month ",
];

export default function RevenueDashboard() {
  const [leadsStats, setLeadsStats] = useState([]);
  const [tableData, setTableData] = useState([]);
  const date = new Date();
  const { userName } = useAuth();
  const [month, setMonth] = useState(months[date.getMonth()]);
  const [year, setYear] = useState(date.getFullYear());
  const columns = [
    { header: "Customer Name", accessor: "customer_name" },
    { header: "Product", accessor: "type" },
    { header: "Purchase date", accessor: "created_at" },
    { header: "Product Title", accessor: "product_title" },
    { header: "Paid", accessor: "total_amt" },
    { header: "Batch", accessor: "batch_name" },
    { header: "Expert Earning", accessor: "expert_earning" },
    { header: "Coupon Used", accessor: "coupon_code" },
    { header: "Status", accessor: "payment_status" },
  ];

  const handleMonth = (event) => {
    setMonth(event);
  };

  const handleYear = (event) => {
    setYear(event);
  };
  const id = Cookies.get("expertID");
  const isValidResponse = (result) => {
    if (
      (result.status === 200 || result.status === 201) &&
      result.data !== null &&
      result.data !== undefined
    ) {
      console.log(result);
      setLeadsStats([
        {
          icon: amount,
          title: "Your Estimated Revenue",
          total: (
            <p className="value size30">₹ {result.data.revenue.current} </p>
          ),
          percentage: (
            <p
              className={`percentage ${
                result.data.revenue.is_increased ? "profit" : "loss"
              }`}
            >
              {result.data.revenue.percentage_change != 0 ? (
                <>
                  <img
                    src={
                      result.data.revenue.is_increased ? priceRise : priceDown
                    }
                    alt="trend-icon"
                  />
                  {result.data.revenue.percentage_change}%
                  <span className="text">from last month</span>
                </>
              ) : (
                ""
              )}
            </p>
          ),
          info: info,
          infocard: <Infocard content={content} position={"left"}></Infocard>,
        },
        {
          icon: dollar,
          title: "Your Estimated Revenue",
          total: (
            <p className="value size30">$ {result.data.revenue.current_usd} </p>
          ),
          percentage: (
            <p
              className={`percentage ${
                result.data.revenue.is_increased ? "profit" : "loss"
              }`}
            >
              {result.data.revenue.percentage_change > 0 ? (
                <>
                  {/* <img src={result.data.revenue.is_increased ? priceRise : priceDown} alt="trend-icon" />
              {result.data.revenue.percentage_change}%
              <span className='text'>from last month</span> */}
                </>
              ) : (
                ""
              )}
            </p>
          ),
        },
        {
          icon: sales,
          title: "Total Sales",
          total: <p className="value size30">{result.data.sales.current}</p>,
          percentage: (
            <p
              className={`percentage ${
                result.data.sales.is_increased ? "profit" : "loss"
              }`}
            >
              {result.data.sales.percentage_change != 0 ? (
                <>
                  <img
                    src={result.data.sales.is_increased ? priceRise : priceDown}
                    alt="trend-icon"
                  />
                  {result.data.sales.percentage_change}%
                  <span className="text">from last month</span>
                </>
              ) : (
                ""
              )}
            </p>
          ),
        },
      ]);
      setTableData(result.data.transactions);
    }
  };
  const getStats = async () => {
    const result = await open_api_with_cookies.get(
      `/dashboard/revenue/overview/?expert_id=${id}&month=${monthsMap[month]}&year=${year}`
    );
    isValidResponse(result);
  };
  useEffect(() => {
    getStats();
  }, [year, month]);
  return (
    <div className="revenue">
      <h2>Hello {userName} 👋🏼,</h2>
      <div className="revenue-filters">
        <FilterChip options={months} selected={month} onSelect={handleMonth} />
        <FilterChip options={years} selected={year} onSelect={handleYear} />
      </div>
      <StatsCard data={leadsStats} isRevenue={true}></StatsCard>
      <TableCard
        columns={columns}
        data={tableData}
        totalEntries={tableData.length}
        currentPage={1}
        totalPages={1}
        isShowJoinButton={false}
        isRevenue={true}
      />
    </div>
  );
}
